import React, { useEffect } from 'react'
import { FaSearch, FaClipboardList, FaUserCircle } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import Button from '@/components/common/Button/Button'
import routes from '@/routes/routes'
import useAuthStore from '@/stores/AuthStore'
import { useProfileStatus } from '@/hooks/useProfile'
import ProviderOnboarding from '@/components/onboarding/ProviderOnboarding'
import Spinner from '@/components/common/Spinner/Spinner'
import './Home.css'

const Home = () => {
    const navigate = useNavigate()
    const { isLogged, getUserDetails } = useAuthStore()
    const { data: profileStatus, isLoading: statusLoading } = useProfileStatus()
    const [userDetails, setUserDetails] = React.useState<any>(null)
    const [loading, setLoading] = React.useState(true)

    useEffect(() => {
        if (isLogged) {
            getUserDetails().then(userData => {
                setUserDetails(userData)
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }, [isLogged, getUserDetails])

    // Check if user is a provider who needs onboarding
    const isProvider = userDetails?.user_type === 'provider'
    const needsOnboarding = isProvider && profileStatus && (!profileStatus.has_services || !profileStatus.has_districts)

    if (loading || statusLoading) {
        return (
            <div className="home-page">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
                    <Spinner />
                </div>
            </div>
        )
    }

    // Show onboarding for providers who haven't completed services and districts
    if (needsOnboarding) {
        return <ProviderOnboarding />
    }

    return (
        <div className="home-page">
            {/* Hero Section */}
            <div className="home-hero">
                <div className="home-hero-content">
                    <h1 className="home-title">¡Bienvenido a Domber!</h1>
                    <p className="home-subtitle">Conecta con los mejores proveedores de servicios en tu área</p>
                    <Button variant="primary" size="lg" onClick={() => navigate(routes.serviceSearch)}>
                        <FaSearch /> Buscar Servicios
                    </Button>
                </div>
            </div>

            <div className="home-container">

                {/* Quick Actions */}
                <div className="home-actions-grid">
                    <div className="home-action-card" onClick={() => navigate(routes.serviceSearch)}>
                        <FaSearch className="home-action-icon" />
                        <h3 className="home-action-title">Buscar Servicios</h3>
                        <p className="home-action-text">Encuentra proveedores cerca de ti</p>
                    </div>
                    <div className="home-action-card" onClick={() => navigate(routes.requests)}>
                        <FaClipboardList className="home-action-icon" />
                        <h3 className="home-action-title">Mis Solicitudes</h3>
                        <p className="home-action-text">Gestiona tus pedidos de servicios</p>
                    </div>
                    <div className="home-action-card" onClick={() => navigate(routes.profile)}>
                        <FaUserCircle className="home-action-icon" />
                        <h3 className="home-action-title">Mi Perfil</h3>
                        <p className="home-action-text">Configura tu cuenta</p>
                    </div>
                </div>

                {/* Features Section */}
                <div className="home-features">
                    <h2 className="home-section-title">¿Por qué Domber?</h2>
                    <div className="home-features-grid">
                        <div className="home-feature-card">
                            <div className="home-feature-number">1</div>
                            <h3 className="home-feature-title">Fácil y Rápido</h3>
                            <p className="home-feature-text">Encuentra y contrata servicios en minutos</p>
                        </div>
                        <div className="home-feature-card">
                            <div className="home-feature-number">2</div>
                            <h3 className="home-feature-title">Proveedores Verificados</h3>
                            <p className="home-feature-text">Todos nuestros proveedores están verificados</p>
                        </div>
                        <div className="home-feature-card">
                            <div className="home-feature-number">3</div>
                            <h3 className="home-feature-title">Pago Seguro</h3>
                            <p className="home-feature-text">Protección de pagos garantizada</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home